var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticStyle: { cursor: "pointer" },
        attrs: {
          headers: _vm.headers,
          items: _vm.annualReviews,
          "hide-default-footer": "",
          "disable-pagination": "",
          "mobile-breakpoint": "0",
        },
        on: {
          "click:row": function ($event) {
            return _vm.editEntry($event)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.date`,
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "d-flex align-center py-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.moment(item.date).tz("UTC").format("MM/DD/YYYY")
                        ) +
                        "\n            "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.reviewer`,
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "d-flex align-center py-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.reviewer.name) +
                        "\n            "
                    ),
                  ]),
                ]
              },
            },
            {
              key: `item.content`,
              fn: function ({ item }) {
                return [
                  _c("div", { staticClass: "d-flex align-center py-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(`${item.content.substring(0, 50)}...`) +
                        "\n            "
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.dialog
        ? _c("SoliForm", {
            ref: "form",
            attrs: {
              title: `${_vm.form.id ? "Edit" : "Create"} Review`,
              text: "Save",
              icon: "save",
              persistent: "",
              large: "",
              loadingProp: _vm.form.processing,
              saveChanges: _vm.editing,
            },
            on: {
              submit: function ($event) {
                return _vm.submit()
              },
              reset: function ($event) {
                return _vm.reset()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliDate", {
                        attrs: {
                          "validate-on-blur": "",
                          rules: [
                            (val) =>
                              (val || "").length > 0 ||
                              "This field is required",
                          ],
                          error: _vm.errors.date,
                          max: _vm.dateMax(),
                        },
                        model: {
                          value: _vm.form.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date",
                        },
                      }),
                      _vm._v(" "),
                      _c("SoliStudents", {
                        key: _vm.form.user?.id,
                        attrs: {
                          label: "Reviewer",
                          onDemand: "",
                          error: _vm.errors.user_id,
                          autocomplete: "",
                        },
                        model: {
                          value: _vm.form.user,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "user", $$v)
                          },
                          expression: "form.user",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        ref: "notes",
                        staticClass: "soli-round",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: "Notes",
                          rules: _vm.contentRules,
                          "error-messages": _vm.errors.content,
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "cancelBtn",
                  fn: function (attrs) {
                    return [
                      !_vm.editing && _vm.form.id
                        ? _c(
                            "SoliBtn",
                            _vm._b(
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  text: "Delete",
                                  icon: "delete",
                                  color: "soli-status-red",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.confirmDelete = _vm.form.id
                                  },
                                },
                              },
                              "SoliBtn",
                              attrs,
                              false
                            )
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              1991477631
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmDelete
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle: "This review will be deleted.",
              button1: "Delete",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.deleteEntry(_vm.confirmDelete)
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.confirmDelete = null))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }